lmApp
  .controller('TileAssetController', ['$scope', '$rootScope', '$interval', '$q', 'ShowcaseService', 'AssetService', 'ManageAssetsWindow', 'ToastService',
    function ($scope, $rootScope, $interval, $q, ShowcaseService, AssetService, ManageAssetsWindow, ToastService) {

      $scope.namespace = 'stockmob';
      $scope.tile = $scope.$parent.tile;
      $scope.loading = false;

      $scope.validate = function (banner) {
        $scope.validateFields = {};

        if (!banner._PrivateData.picture) {
          $scope.validateFields.picture = 'Required filed';
        }

        return $scope.validateFields;
      };

      $scope.openSearch = function (item) {
        ManageAssetsWindow.OpenManageAssetsWindow({
          manageAssetsFn: function (asset, toThis) {
            if ($scope.loading) return;

            if (asset.id) {
              $scope.addAssetToTile(item, asset);
            }

            return $q.when(true);
          },
          type: 'single',
          title: 'slider item',
          view: 'vod,live',
          currentCollection: [item.banner._PrivateData.asset.id],
          filter: {
            packages: true
          }
        });
      };

      $scope.updateWidget = function (tile) {
        if ($scope.loading) return;

        if (!_.isEmpty($scope.validate(tile.banner))) {
          return;
        }

        ShowcaseService.UpdateAssetWidget(tile.banner)
          .then(function (response) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#showcasesLoader');
            ToastService.Small({
              title: 'Widget successfully update',
              color: 'green',
              icon: 'layers'
            });
            if (!tile._PrivateData.isSliderInner) $scope.close(tile);
          })
          .catch(function (reason) {
            ToastService.Small({
              title: 'Widget update failed',
              color: 'red',
              icon: 'layers'
            });
            $scope.loading = false;
            $rootScope.hideLinearProgress('#showcasesLoader');
            $rootScope.debugInfo(reason);
          });
      };

      $scope.createWidget = function (item) {
        if ($scope.loading) return;

        if (!_.isEmpty($scope.validate(item.banner))) {
          return;
        }

        ShowcaseService.CreateAssetWidget(item.banner, $scope.namespace)
          .then(function (response) {
            item.banner.id = response.widget.id;

            if (item._PrivateData.isSliderInner) {
              $scope.$parent.createNewSliderItem(item)
            } else {
              $scope.$parent.createNewTile(item);
            }
          })
          .catch(function (reason) {
            ToastService.Small({
              title: 'Widget create failed',
              color: 'red',
              icon: 'layers'
            });
            $scope.loading = false;
            $rootScope.hideLinearProgress('#showcasesLoader');
            $rootScope.debugInfo(reason);
          });
      };

      $scope.close = function (tile, event) {
        if (event && event.stopPropagation) event.stopPropagation();
        if (event && event.preventDefault) event.preventDefault();
        if ($scope.loading) return;

        if (tile.isNew) {
          $scope.$parent.deleteTile(tile, event)
        } else {
          $scope.$parent.collapseTile(tile);
        }
      };

      $scope.addAssetToTile = function (tile, asset) {
        tile.banner._PrivateData.uiTitle = asset.title;

        if (!tile._PrivateData.isSliderInner) {
          var pictureResources = asset.resources && asset.resources.filter(function (resourse) {
              return resourse.category === 'poster_blueprint';
            });

          if (pictureResources && pictureResources.length) {
            tile.banner._PrivateData.picture = pictureResources[0].source;
          }

        }

        tile.banner._PrivateData.searchResult = [];
        tile.banner._PrivateData.keyword = '';
        tile.banner._PrivateData.selectedAsset = {};

        tile.banner._PrivateData.asset = asset;
        tile.banner._PrivateData.asset.duration = parseInt(asset.duration / 60, 10);

        if (asset.genres) {
          tile.banner._PrivateData.asset.genres = asset.genres.map(function (genre) {
            return genre.title;
          });
        }
      };

    }]);
